import { gql, useMutation } from "@apollo/client";
import React, { useState } from "react";
import { remove } from "react-cookies";
import { useToken } from "src/components/authentication/TokenProvider";
import { BreadCrumb, BreadCrumbProp } from "../../components/light/Breadcrumb";
import { Content } from "../../components/light/Content";
import { SectionBlock } from "../../components/light/SectionBlock";
import { Toast } from "../../hooks/toast";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "Account", to: "#" },
  { text: "Reset Password", to: "/account/resetpassword" },
];

const CHANGEPASSWORD = gql`
  mutation changeMerchantPassword($oldPassword: String!, $newPassword: String!) {
    changeMerchantPassword(oldPassword: $oldPassword, newPassword: $newPassword)
  }
`;

export function ResetPasswordScreen() {
  const context = useToken();
  const [password, setPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [changeMerchantPassword] = useMutation(CHANGEPASSWORD, {
    onCompleted: (res) => {
      if (res.changeMerchantPassword) {
        const legacy = (window as any).setting.legacy as string;
        const host = window.location.hostname.split(".");
        localStorage.removeItem("token");
        context.setToken(null);
        remove("lf_merchant_token", {
          domain: host[host.length - 2] + "." + host[host.length - 1],
        });
        window.location.href = `${legacy}/logout2`;
        Toast.onShow("Change was success please login again with new password", "success", "right");
      }
    },
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    changeMerchantPassword({
      variables: {
        oldPassword: password,
        newPassword: newpassword,
      },
    });
  };

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-5">
          <SectionBlock title="Reset Password">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Current Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter password"
                  value={newpassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>
              <button className="btn btn-primary btn-sm">Reset</button>
            </form>
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}
